import { createContext } from 'react';
import { noop } from 'lodash';
import { CHAT_SERVICE_MODE } from '../../config/chatServiceMode';

export const ChatAgentContext = createContext({
    registerGrid: noop,
    openChat: noop,
    closeChat: noop,
    clearWindowList: noop,
    setChatReady: noop,
    registerWizard: noop,
    sendMessageToChat: noop,
    chatServiceMode: CHAT_SERVICE_MODE.CHAT_AGENT,
});
